module.exports = __webpack_public_path__ + "img/hzbdy.f0d5b0d.png";